const header = document.querySelector('[data-rh3-header]');

if (header instanceof HTMLElement && header.dataset.initialized !== 'true') {
  header.dataset.initialized = 'true';
  header.closest('.shopify-section')?.classList.add('rh3-header-section');
  header.closest('#header-group')?.classList.add('rh3-header-group');

  const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 18);
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  const drawer = header.querySelector('[data-rh3-mobile-menu]');
  const openButton = header.querySelector('[data-rh3-menu-open]');
  const closeButton = header.querySelector('[data-rh3-menu-close]');
  const backdrop = header.querySelector('[data-rh3-menu-backdrop]');
  let previousFocus = null;
  let closingTimer = 0;

  const focusableItems = () => drawer
    ? [...drawer.querySelectorAll('a[href], button:not([disabled])')]
    : [];

  const setOpen = (open) => {
    if (!(drawer instanceof HTMLElement) || !(openButton instanceof HTMLButtonElement) || !(backdrop instanceof HTMLElement)) return;
    window.clearTimeout(closingTimer);
    openButton.setAttribute('aria-expanded', String(open));
    drawer.setAttribute('aria-hidden', String(!open));
    document.body.classList.toggle('rh3-menu-open', open);
    if (open) {
      previousFocus = document.activeElement;
      drawer.hidden = false;
      backdrop.hidden = false;
      requestAnimationFrame(() => {
        drawer.classList.add('is-open');
        backdrop.classList.add('is-open');
        if (closeButton instanceof HTMLButtonElement) closeButton.focus();
      });
      return;
    }
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    if (previousFocus instanceof HTMLElement) previousFocus.focus();
    closingTimer = window.setTimeout(() => {
      drawer.hidden = true;
      backdrop.hidden = true;
    }, 220);
  };

  openButton?.addEventListener('click', () => setOpen(true));
  closeButton?.addEventListener('click', () => setOpen(false));
  backdrop?.addEventListener('click', () => setOpen(false));
  drawer?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setOpen(false)));

  document.addEventListener('keydown', (event) => {
    if (!(drawer instanceof HTMLElement) || drawer.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      setOpen(false);
      return;
    }
    if (event.key !== 'Tab') return;
    const items = focusableItems();
    const first = items[0];
    const last = items.at(-1);
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last?.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first?.focus();
    }
  });
}
